import React, { useRef } from "react";
import { Carousel } from "primereact/carousel";
import PropertyListCard from "../../common/property-list-card";
import styles from "../related-properties/related-properties.module.scss";
import { RelatedPropertiesProps } from "./related-properties.interface";
import SkeletonC from "../../common/skeleton";
import PropertyListCardSkeleton from "../../../skeleton/card-skeleton";
import { useRelatedProperties } from "../../../hooks/react-query/properties/useRelatedProperty";
import { StatusObjectColorFilter } from "../../../utils/utils";
// import { useParams } from "react-router-dom";
const RelatedProperties = ({
  title,
  currencyCode,
  locale,
  loading,
  _propertyId
}: RelatedPropertiesProps) => {
  const { data: relatedPropertyList } = useRelatedProperties(_propertyId);
  const carouselRef: any = useRef<Carousel>(null);
  // const { propertyId: propertyIdParams } = useParams();

  const responsiveOptions = [
    {
      breakpoint: "1450px",
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1
    }
  ];

  const productTemplate = (property: any) => {
    if (loading) {
      return <PropertyListCardSkeleton />;
    } else {
      return (
        <PropertyListCard
          loginType="agent"
          sfid={property?.sfid}
          id={property.id}
          lat={property?.latitude}
          lng={property?.longitude}
          className={styles.relatedCard}
          imageUrl={property.posterImage}
          // score={property.score}
          bedRooms={property.beds || property?.bedRooms}
          totalBath={property?.baths || property?.totalBath}
          sqft={property?.sqft}
          shape={"circle"}
          listedTitle={"Listed By"}
          defaultProfile={property?.acquisitionAgent1?.bannerPhotoUrl}
          agentFirstName={property?.acquisitionAgent1?.name?.split(" ")[0]}
          agentLastName={property?.acquisitionAgent1?.name?.split(" ")[1]}
          salesInstruction={property?.salesInstruction}
          street={property?.street}
          location={property?.location}
          amount={property.askingPrice}
          currencyCode={currencyCode}
          locale={locale}
          propertyId={property?.id}
          park={property?.park}
          property={property}
          city={property?.city}
          state={property?.state}
          postalCode={property?.postalcode}
          favCount={property?.favCount}
          status={StatusObjectColorFilter(property?.status)}
          statusValue={property?.status}
          activatedAt={property?.activatedAt}
          shareKey={property?.shareKey}
          offerDueDateAndTime={property?.offerDueDateAndTime}
          opportunitySfid={property?.opportunitySfid}
          pubPropertySfid={property?.pubPropertySfid}
          objPropertyDetails={property}
        />
      );
    }
  };

  return (
    <div className={styles.relatedProperties}>
      {loading ? (
        <>
          {/* <div className={styles.title}>{title}</div> */}
          <SkeletonC
            width="30%"
            height="2.5rem"
            shape="rectangle"
            className={styles.title}
          />
          <SkeletonC
            width="100%"
            height="292px"
            shape="rectangle"
            className="mb-4"
          />
        </>
      ) : (
        <>
          {relatedPropertyList?.length > 0 && (
            <>
              <div className={styles.title}>{title}</div>
              {relatedPropertyList.length > 4 ? (
                <Carousel
                  value={relatedPropertyList}
                  ref={carouselRef}
                  numVisible={4}
                  numScroll={1}
                  responsiveOptions={responsiveOptions}
                  itemTemplate={productTemplate}
                  showIndicators={false}
                  showNavigators={relatedPropertyList.length > 4}
                />
              ) : (
                <div className={styles.cardRelated}>
                  {relatedPropertyList.map((property: any) => (
                    <React.Fragment key={property.id}>
                      {productTemplate(property)}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};
export default React.memo(RelatedProperties);
